import React from 'react';

import { observer } from 'mobx-react';
import { EditResourceLibrary } from './EditResourceLibrary/EditResourceLibrary';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { ViewResourceLibrary } from './ViewResourceLibrary/ViewResourceLibrary';
import { VideoPageType } from '../../constants/videoPage';

type ResourceLibraryProps = {
  page: VideoPageType;
};

/**
 * Tab-based resource library page that switches between view and edit mode based on user role.
 * Super admins get the edit mode (EditResourceLibrary) with CRUD capabilities;
 * all other users get the read-only view (ViewResourceLibrary).
 *
 * Category tabs are only rendered when there is more than one category available —
 * a single category renders its content directly without a tab bar.
 */
const ResourceLibrary = observer(({ page }: ResourceLibraryProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  if (isSuperAdmin) {
    return <EditResourceLibrary page={page} />;
  }

  return <ViewResourceLibrary page={page} />;
});

export { ResourceLibrary };
